import { lazy } from 'react';

export const PlayerWithdrawalLimitsForm = lazy(
  () => import('./PlayerWithdrawalLimitsForm'),
);
